import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js"; // UTC plugin
import timezone from "dayjs/plugin/timezone.js"; // Timezone plugin
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export const groupMatchesByLeagueId = (data) => {
  const filteredLeagues = data.reduce((leagues, currentMatch) => {
    if (!currentMatch) {
      return leagues;
    }

    const { league, ...restMatch } = currentMatch;

    const leagueId = league?.id;
    if (!leagueId) {
      return leagues;
    }

    if (!leagues[leagueId]) {
      leagues[leagueId] = {
        ...league,
        matches: [restMatch],
      };
    } else {
      leagues[leagueId].matches.push(restMatch);
    }

    return leagues;
  }, {});

  return filteredLeagues ? Object.values(filteredLeagues) : [];
};

export const formatDateForApi = (date) => {
  return getTodayDate({ date });
};

export const getTodayDate = ({ date }) => {
  if(!date) {
    return dayjs().tz("Asia/Ho_Chi_Minh").format("YYYY-MM-DD");
  }

  const dateVN = dayjs(date).tz("Asia/Ho_Chi_Minh");
  return dateVN.format("YYYY-MM-DD");
};

export const formatDateTime = (matchTimeInUnix) => {
  const dateTime = dayjs.unix(matchTimeInUnix).tz("Asia/Ho_Chi_Minh");
  const date = dateTime.format("DD/MM");
  const time = dateTime.format("HH:mm");

  return { date, time };
};

export const formatVNTime = (date) => {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Ho_Chi_Minh",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(date);
  const hour = parts.find((p) => p.type === "hour").value;
  const minute = parts.find((p) => p.type === "minute").value;

  return `${hour}:${minute}`;
};

export const formatHandicapLabel = (value, isHome) => {
  const num = parseFloat(value);
  if (isHome) {
    return num > 0 ? `-${value}` : value || "-1";
  }
  return num < 0 ? Math.abs(num) : `+${value || 1}`;
};

const THU_VI = ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"];

export const formatUnixToVNDate = (unixTimestamp) => {
  const d = dayjs.unix(unixTimestamp).tz("Asia/Ho_Chi_Minh");
  return {
    date: d.format("DD/MM"),
    thu: THU_VI[d.day()],
    gio: d.format("HH:mm"),
  };
};
